export const objectPick = <T extends Record<string, unknown>>(
  obj: T,
  keys: string[],
) => {
  return keys.reduce<Record<string, unknown>>((acc, key) => {
    if (key in obj) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};
